//Creates new solution and adds to array of solutions
export const createSolution = (data) => {
    //data = {id, solution}
    return { type: "CREATE_SOLUTION", payload: data}
}

//set solution of solution obj with specific id
export const setSolution = (data) => {
    //data = {id, solution}
    return { type: "SET_SOLUTION", payload: data}
}

export const setSolutionMixed = data => {
  return { type: "SET_SOLUTION_MIXED", payload: data };
};

export const setSolutionIncubated = data => {
    return { type: "SET_SOLUTION_INCUBATED", payload: data };
};

//Change lid open status of solution with specific id
export const solutionOpen = (data) => {
    //data = {id, open}
    return { type: "SOLUTION_OPEN", payload: data}
}

//set solution of solution obj with specific id
export const incSolution = (data) => {
    //data = {id, solution}
    return { type: "INC_SOLUTION", payload: data}
}

//Change lid open status of solution with specific id
export const decSolution = (data) => {
    //data = {id, open}
    return { type: "DEC_SOLUTION", payload: data}
}

//Hide solution when dragged over to microcentrifuge with specific id
export const setSolutionInScene = (data) => {
    //data = {id, inScene}
    return { type: "SET_SOLUTION_IN_SCENE", payload: data}
}

//Determine if solution is on rack
export const setSolutionOnRack = (data) => {
    //data = {id, inScene}
    return { type: "SET_SOLUTION_ON_RACK", payload: data}
}

//Determine if Solution is in Ice
export const setSolutionOnIce = (data)=>{
    return {type : "SET_SOLUTION_ON_ICE", payload:data}
}


export const setSolutionHeld = (data) => {
    //data = {id, inScene}
    return { type: "SET_SOLUTION_HELD", payload: data}
}

export const setSolutionHomogenized = (data) => {
    //data = {id, homogenized}
    return { type: "SET_SOLUTION_HOMOGENIZED", payload: data}
}

//Set whether the flask controls are displayed or not
export const setSolutionControlVisibility = (data) => {
    //data = {id, animatingOut}
    return { type: "SET_SOLUTION_CONTROLS_VISIBLE", payload: data}
}

//Display the solution contents list
export const setShowSolutionContents = (data) => {
    return { type: "SHOW_SOLUTION_CONTENTS", payload: data}
}
